export default __webpack_public_path__ + "static/media/blocked.5ae041f1.svg";